export enum DigitisationFilterStatus {
  DIGITISED = 'digitised',
  DIGITISATION_PENDING = 'digitisation-pending',
  NO_DIGITISATION = 'no-digitisation',
}

export type DigitisationStatusFilterAndLabel = {
  value: DigitisationFilterStatus;
  label: string;
};

export const DIGITISED_STATUS_FILTER: DigitisationStatusFilterAndLabel = {
  value: DigitisationFilterStatus.DIGITISED,
  label: 'Digitised',
};

export const DIGITISATION_PENDING_STATUS_FILTER: DigitisationStatusFilterAndLabel =
  {
    value: DigitisationFilterStatus.DIGITISATION_PENDING,
    label: 'Digitisation Pending',
  };

export const NO_DIGITISATION_STATUS_FILTER: DigitisationStatusFilterAndLabel = {
  value: DigitisationFilterStatus.NO_DIGITISATION,
  label: 'No Digitisation',
};

export const ALL_DIGITISATION_STATUS_FILTERS: DigitisationStatusFilterAndLabel[] =
  [
    DIGITISED_STATUS_FILTER,
    DIGITISATION_PENDING_STATUS_FILTER,
    NO_DIGITISATION_STATUS_FILTER,
  ];
